import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppSettingsService } from '../../services/app-settings.service';
import { AuthService, UserData } from '../../services/auth.service';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { HelpComponent } from '../../pages/help/help.component';
import { CompanyChatService } from '../../company-chat.service';
import { AppRole } from 'digiteq-ai-portal-client-lib';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  userMenuItems: MenuItem[] | undefined;
  adminMenuItems: MenuItem[] | undefined;

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated;
  };

  get currentUser(): UserData {
    return this.authService.currentUser;
  }

  get heading(): string {
    switch (this.router.url) {
      case '/chat': return this.selectedModelName;
      case '/company-chat': return this.daiseService.daiseHeading;
      case '/file-chat': return 'File Chat';
      default: return '';
    }
  }

  get selectedModelName(): string {
    return this.settingsService.getSelectedModelName();
  }

  get isAdmin(): boolean {
    return this.authService.isInRoles([AppRole.DqaiAdmin])
  }

  constructor(
    private settingsService: AppSettingsService,
    private authService: AuthService,
    private router: Router,
    private dialog: DialogService,
    private daiseService: CompanyChatService,
  ) {}

  ngOnInit() {
    this.userMenuItems = [
      {
        label: 'My issues',
        icon: 'pi pi-check-square',
        routerLink: 'work-items'
      },
      {
        separator:true
      },
      {
        label: 'Log out',
        icon: 'pi pi-sign-out',
        command: () => { this.logout()}
      },
    ];

    this.adminMenuItems = [
      {
        label: 'DAISE indexes',
        icon: 'pi pi-cog',
        command: () => { this.showDaiseIndexesAdministration() }
      },
      {
        label: 'Personas',
        icon: 'pi pi-users',
        command: () => { this.showPersonasAdministration() }
      },
       {
        label: 'Models',
        icon: 'pi pi-box',
        command: () => { this.showModelsAdministration() }
      },
    ];
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  toLandingPage() {
     void this.router.navigate(['home']);
  }

  showHelp() {
    this.dialog.open(HelpComponent, {
      modal: true,
      width: '75%',
    })
  }

  showDaiseIndexesAdministration() {
    void this.router.navigate(['company-chat-admin']);
  }

  showPersonasAdministration() {
    void this.router.navigate(['personas-admin']);
  }

  showModelsAdministration() {
    void this.router.navigate(['models-admin']);
  }

}
